var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrivacy = function SvgPrivacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.14 2.44 7.54.108a1.4 1.4 0 0 0-1.077 0l-5.6 2.334A1.4 1.4 0 0 0 0 3.733c0 5.79 3.34 9.79 6.46 11.092.345.143.732.143 1.077 0C10.037 13.783 14 10.187 14 3.733a1.4 1.4 0 0 0-.86-1.292M7.003 13.017 7 1.904l5.13 2.138c-.096 4.416-2.394 7.615-5.127 8.974"
  })));
};
export default SvgPrivacy;